import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';

import { Inline, Text } from '@atlaskit/primitives/compiled';
import { ColorPicker, DEFAULT_GRAY_COLOR, useBuiltInColorMap } from '@atlassian/color-picker';
import { useProductDependencies } from '@atlassian/company-hub-common';

import { CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE } from '../../../../constants';
import type { CardsActions } from '../../../../controllers/use-cards-extension-parameters-and-actions/types';

import { messages } from './messages';

type BorderColorFieldProps = {
	borderColor: string | undefined;
	isCompanyHub: boolean;
	updateMainFormField: CardsActions['updateMainFormField'];
};

export const BorderColorField = ({
	borderColor,
	isCompanyHub,
	updateMainFormField,
}: BorderColorFieldProps): React.JSX.Element => {
	const { isSSRProductInDarkMode } = useProductDependencies();
	const { branding } = useProductDependencies();
	const { hideDefaultColorPalette, brandBackgroundColorMap } = branding ?? {};
	const { backgroundColorMap } = useBuiltInColorMap(isSSRProductInDarkMode);

	const defaultBorderColor = DEFAULT_GRAY_COLOR;

	const handleChange = useCallback(
		(color: string) => {
			updateMainFormField({ borderColor: color });
		},
		[updateMainFormField],
	);

	return (
		<Inline alignBlock="center" spread="space-between">
			<Text color="color.text">
				<FormattedMessage {...messages.borderColor} />
			</Text>
			<ColorPicker
				builtInColorMap={
					hideDefaultColorPalette && brandBackgroundColorMap
						? brandBackgroundColorMap
						: backgroundColorMap
				}
				onChange={handleChange}
				value={borderColor || defaultBorderColor}
				pickerTitle={messages.borderColor}
				showCustomPalette={isCompanyHub}
				analyticsSource={CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE}
			/>
		</Inline>
	);
};
